export class ChangeSecurityQuestionsEventType {

	static SEND = {
		CHANGE_SECURITY_QUESTIONS_CONFIRM_SEND: 'CHANGE_SECURITY_QUESTIONS_CONFIRM_SEND'
	};

	static STEPS = {
		CHANGE_SECURITY_QUESTIONS: 'CHANGE_SECURITY_QUESTIONS',
		CHANGE_SECURITY_QUESTIONS_CONFIRM: 'CHANGE_SECURITY_QUESTIONS_CONFIRM',
		CHANGE_SECURITY_QUESTIONS_RESULT: 'CHANGE_SECURITY_QUESTIONS_RESULT'
	};

	static LOGIN = {
		SMS_VALIDATION: 'SMS_VALIDATION'
	};


	static ERROR = 'CHANGE_SECURITY_QUESTIONS_ERROR';
	static BUTTONS = 'CHANGE_SECURITY_QUESTIONS_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-security-questions/change-security-questions.event.type.ts